import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './components/App';
import AlphaPortal from './components/AlphaPortal';
import config from './config.js';
import reportWebVitals from './reportWebVitals';
import { localDebugEnabled } from './shared/localDebug';

const LocalPortal = process.env.REACT_APP_ADENREL_PROFILE === 'alpha' ? () => null : require('./components/LocalPortal').default;

const expectedProfile = config.server.profile || 'authoring';
const runtimeProfileUrl = `${config.server.url}:${config.server.webServicesPort}/runtime-profile`;

function RuntimeProfileBanner() {
  const [mismatch, setMismatch] = useState('');

  useEffect(() => {
    fetch(runtimeProfileUrl)
      .then((response) => response.ok ? response.json() : Promise.reject(new Error(`HTTP ${response.status}`)))
      .then((runtime) => {
        if (runtime.profile !== expectedProfile) {
          setMismatch(`Expected ${expectedProfile}, but API ${runtime.port} is using ${runtime.profile}.`);
        }
      })
      .catch((error) => setMismatch(`Cannot verify the ${expectedProfile} API: ${error.message}`));
  }, []);

  if (expectedProfile !== 'playtest' && !mismatch) {
    return null;
  }

  return (
    <div className={`runtime-profile-banner${mismatch ? ' runtime-profile-banner--error' : ''}`} role="status">
      {mismatch || `PLAYTEST DATABASE · API ${config.server.webServicesPort}`}
    </div>
  );
}

if (expectedProfile === 'playtest') {
  document.title = `[PLAYTEST] ${document.title}`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {expectedProfile === 'alpha' ? <AlphaPortal /> : <><RuntimeProfileBanner />
      {localDebugEnabled() && window.location.pathname !== '/admin' ? <LocalPortal /> : <App />}</>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
